"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compareInterimBillsQuerySchema = exports.cancelInterimBillSchema = exports.generateInterimBillSchema = exports.ipInterimBillStatusEnum = void 0;
const zod_1 = require("zod");
/** IP interim bill contracts — ADR-085 Phase 8. */
exports.ipInterimBillStatusEnum = zod_1.z.enum(['GENERATED', 'PRINTED', 'CANCELLED', 'SUPERSEDED']);
/**
 * Generation takes NO financial input. The snapshot is computed server-side
 * from the ledgers — a caller-supplied total would be a number the bill could
 * not later justify.
 */
exports.generateInterimBillSchema = zod_1.z.object({
    generationReason: zod_1.z.string().max(255).optional(),
});
exports.cancelInterimBillSchema = zod_1.z.object({
    reason: zod_1.z.string().min(1).max(1000),
});
exports.compareInterimBillsQuerySchema = zod_1.z.object({
    fromSnapshotId: zod_1.z.string().uuid(),
    toSnapshotId: zod_1.z.string().uuid(),
});
//# sourceMappingURL=ip-interim-bill.schema.js.map